import {
	ChangeDetectionStrategy,
	Component,
	inject,
	OnInit,
	output,
} from '@angular/core';
import { NewGraphSettings } from '@app/pages/cmms/components/assets/asset-time-series/misc/interfaces';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'new-time-series-settings-form',
	templateUrl: './new-time-series-settings-form.component.html',
	styleUrls: ['./new-time-series-settings-form.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatInputModule,
		MatIconModule,
		ReactiveFormsModule,
		MatButtonModule,
		NgxTolgeeModule,
	],
})
export class NewTimeSeriesSettingsFormComponent implements OnInit {
	private readonly fb = inject(FormBuilder);

	submitNewTimeSeriesSettings = output<NewGraphSettings>();
	closeNewGraphSettings = output<void>();

	formGroup: FormGroup;

	ngOnInit() {
		this.formGroup = this.fb.group({
			name: ['', [Validators.required, Validators.maxLength(100)]],
			value: [''],
			unit: ['', Validators.maxLength(50)],
			description: ['', Validators.maxLength(250)],
		});
	}

	submit() {
		if (this.formGroup.valid) {
			this.submitNewTimeSeriesSettings.emit({
				name: this.formGroup.get('name').value,
				value: +this.formGroup.get('value').value,
				unit: this.formGroup.get('unit').value,
				description: this.formGroup.get('description').value,
			});
		}
	}

	cancelSubmit() {
		this.closeNewGraphSettings.emit();
	}
}
